export function isDevelopment() {
  // Check if we're running on a dev domain
  const isDevDomain = typeof window !== 'undefined' && window.location.hostname.includes('app-dev');

  // Return true if NODE_ENV is development, undefined, or if we're on a dev domain
  return !process.env.NODE_ENV || process.env.NODE_ENV == "development" || isDevDomain;
}

export function isLocalDevelopment() {
  // Check if we're running locally (localhost or 127.0.0.1)
  const isLocalhost = typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1' ||
      window.location.hostname === '[::1]');

  // Return true only if localhost AND NODE_ENV is development or undefined
  return isLocalhost && (!process.env.NODE_ENV || process.env.NODE_ENV == "development");
}

export function useEnvironment() {
  return [isDevelopment, isLocalDevelopment];
}
